const ONGLETS = [
  { cle: 'terrain', libelle: 'Terrain', icone: (c) => <rect x="2" y="4" width="20" height="16" rx="2" stroke={c} strokeWidth="1.6" fill="none" /> },
  { cle: 'effectif', libelle: 'Effectif', icone: (c) => <><circle cx="9" cy="8" r="3.2" stroke={c} strokeWidth="1.6" fill="none" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke={c} strokeWidth="1.6" fill="none" strokeLinecap="round" /><circle cx="17" cy="9" r="2.4" stroke={c} strokeWidth="1.4" fill="none" /></> },
  { cle: 'memoire', libelle: 'Mémoire', icone: (c) => <><rect x="3" y="4" width="18" height="16" rx="2.5" stroke={c} strokeWidth="1.6" fill="none" /><path d="M7 9h10M7 13h7" stroke={c} strokeWidth="1.6" strokeLinecap="round" /></> },
];

/**
 * Trois onglets, pas six écrans.
 *
 * Le tableau tactique et le mode match ont disparu en tant qu'écrans : le premier
 * animait des positions qu'aucune source ne fournit, le second dupliquait un chrono
 * que trois autres surfaces donnent déjà mieux. Ce qu'ils avaient d'utile est sur le
 * Terrain — un interrupteur avec/sans ballon, et un bandeau de match.
 */
export function BarreOnglets({ actif, onChanger, alerte }) {
  return (
    <nav style={{
      flex: 'none', display: 'grid', gridTemplateColumns: `repeat(${ONGLETS.length}, 1fr)`,
      background: 'var(--surf)', borderTop: '1px solid var(--line)',
      // Douze pixels de respiration sous les libellés.
      //
      // Six suffisaient à éviter le bord, mais la barre paraissait posée trop bas : le
      // système réserve déjà sa bande sous elle, et sans un peu d'air les libellés
      // touchent presque cette bande. Douze les décollent sans rouvrir la marge que
      // toute cette affaire a servi à fermer.
      //
      // La réserve pour l'indicateur home a disparu en même temps que
      // `viewport-fit=cover` : le système garde désormais cette bande pour lui, et la
      // reprendre ici la comptait deux fois — c'était la « marge de fou » sous la
      // barre. Sans `cover`, l'inset vaut zéro ; le `max` ne sert qu'aux navigateurs
      // qui le rapporteraient quand même, et le plafond de 34 px empêche qu'une valeur
      // aberrante rouvre la brèche.
      paddingBottom: 'min(34px, max(env(safe-area-inset-bottom), 12px))',
      // Plancher sur les onglets seuls : un inset mal rapporté ne doit pas pouvoir
      // rétrécir la barre au point de couper ses libellés.
      minHeight: 49,
    }}>
      {ONGLETS.map((o) => {
        const on = actif === o.cle;
        const c = on ? 'var(--acc)' : 'var(--ink2)';
        return (
          <button
            key={o.cle}
            onClick={() => onChanger(o.cle)}
            aria-current={on ? 'page' : undefined}
            style={{ height: 49, flex: 'none', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3, overflow: 'visible' }}
          >
            <span style={{ position: 'relative', display: 'flex' }}>
              <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">{o.icone(c)}</svg>
              {/* La pastille ne dit pas quoi faire, elle dit qu'il y a quelque chose à
                  voir. Le détail est dans l'onglet, pas dans un point de six pixels. */}
              {alerte === o.cle && (
                <span style={{ position: 'absolute', top: -3, right: -5, width: 8, height: 8, borderRadius: '50%', background: 'var(--warn)', border: '1.5px solid var(--surf)' }} />
              )}
            </span>
            <span style={{ fontSize: 10, fontWeight: 700, color: c }}>{o.libelle}</span>
          </button>
        );
      })}
    </nav>
  );
}
